const ShowFrontPage = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Briefcase/ShowFrontPage`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) return { success: false, message: 'Error al mostrar la portada' };
        return { success: true };
    } catch (error) {
        return { success: false, message: 'Error de red al mostrar la portada.' };
    }
};

const StartGame = async (configData) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Briefcase/start`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(configData)
        });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            return { success: false, message: errorData.message || 'Error al iniciar el juego' };
        }
        const data = await response.json();
        return { success: true, data: data };
    } catch (error) {
        return { success: false, message: 'Error de red.' };
    }
};

const OpenBriefcase = async (briefcaseId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Briefcase/open`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ briefcaseId })
        });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            return { success: false, message: errorData.message || 'Error al abrir maletín' };
        }
        const data = await response.json();
        return { success: true, data: data };
    } catch (error) {
        return { success: false, message: 'Error de red.' };
    }
};

const ResetGame = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Briefcase/reset`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            return { success: false, message: errorData.message || 'Error al reiniciar' };
        }
        return { success: true };
    } catch (error) {
        return { success: false, message: 'Error de red.' };
    }
};

const ContinueGame = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Briefcase/Continue`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) return { success: false, message: 'Error al continuar' };
        return { success: true };
    } catch (error) {
        return { success: false, message: 'Error de red.' };
    }
};


// //--- Admin ---//

// const ShowFrontPage = async () => {
//     try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}Briefcase/ShowFrontPage`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' }
//         });
//         if (!response.ok) return { success: false, message: 'Error al mostrar la portada' };
//         return { success: true };
//     } catch (error) {
//         return { success: false, message: 'Error de red al mostrar la portada.' };
//     }
// };

// const AdminStartGame = async (configurationData) => {
//     try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}Briefcase/Start`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify(configurationData)
//         });
//         if (!response.ok) {
//             const errorData = await response.json().catch(() => ({}));
//             return { success: false, message: errorData.message || 'Error al iniciar el juego de maletines.' };
//         }
//         const responseData = await response.json();
//         return { success: true, data: responseData };
//     } catch (error) {
//         return { success: false, message: 'Error de red al iniciar el juego.' };
//     }
// };

// const AdminOpenBriefcase = async (briefcaseIdentifier) => {
//     try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}Briefcase/Open`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ briefcaseId: briefcaseIdentifier })
//         });
//         if (!response.ok) {
//             const errorData = await response.json().catch(() => ({}));
//             return { success: false, message: errorData.message || 'Error al abrir el maletín.' };
//         }
//         return { success: true };
//     } catch (error) {
//         return { success: false, message: 'Error de red al abrir maletín.' };
//     }
// };

// const AdminResetGame = async () => {
//     try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}Briefcase/Reset`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' }
//         });
//         if (!response.ok) return { success: false, message: 'Error al reiniciar el juego.' };
//         return { success: true };
//     } catch (error) {
//         return { success: false, message: 'Error de red al reiniciar.' };
//     }
// };

// //--- Admin ---//

export { ShowFrontPage, StartGame, OpenBriefcase, ResetGame, ContinueGame };